import {
  ChangeDetectionStrategy,
  Component,
  ViewContainerRef
} from '@angular/core';
import { WorkshopJobEventType } from '../../../models/workshop-job-event';
import { ViewWorkshopJobStoreService } from '../view-workshop-job-store.service';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { AssessmentDialogComponent } from '../event-dialogs/assessment-dialog/assessment-dialog.component';
import { QuotationDialogComponent } from '../event-dialogs/quotation-dialog/quotation-dialog.component';
import { QuoteApprovedComponent } from '../event-dialogs/quote-approved/quote-approved.component';
import { WaitingForPartsDialogComponent } from '../event-dialogs/waiting-for-parts/waiting-for-parts-dialog.component';
import { RepairStartedDialogComponent } from '../event-dialogs/repair-started/repair-started-dialog.component';
import { CompletedDialogComponent } from '../event-dialogs/completed/completed-dialog.component';
import { CancelDialogComponent } from '../event-dialogs/cancelled/cancel-dialog.component';
import { WORKSHOP } from '../../../../testIds';
import { ButtonLabelPipe } from './button-label.pipe';
import { WorkshopJobStatusLabelPipe } from '../../../shared/pipes/workshop-job-status-label.pipe';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-add-event-buttons',
    templateUrl: './add-event-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgxSkeletonLoaderModule, MatButton, MatMenuTrigger, MatIcon, MatMenu, NgFor, MatMenuItem, AsyncPipe, WorkshopJobStatusLabelPipe, ButtonLabelPipe]
})
export class AddEventButtonsComponent {
  testIds = WORKSHOP;
  private eventTypesInOrder: WorkshopJobEventType[] = [
    'booked_in',
    'assessment',
    'quotation',
    'quote_approved',
    'waiting_for_parts',
    'repair_started',
    'completed'
  ];

  private otherEventTypes: WorkshopJobEventType[] = [
    'assessment',
    'quotation',
    'quote_approved',
    'waiting_for_parts',
    'repair_started',
    'completed',
    'cancelled'
  ];

  loading$ = this.store.jobAndEventsLoading$;
  currentStatus$ = this.store.job$.pipe(map((job) => job.work_status));

  primaryAddEventType$ = this.currentStatus$.pipe(
    map((status) => {
      const index = this.eventTypesInOrder.indexOf(
        status === 'assessed' ? 'assessment' : status
      );
      return this.eventTypesInOrder[index + 1];
    })
  );
  otherEventTypes$ = this.primaryAddEventType$.pipe(
    map((primaryButtonType) => {
      return this.otherEventTypes.filter((type) => type !== primaryButtonType);
    })
  );
  hideButtons$ = this.currentStatus$.pipe(
    map((status) => ['completed', 'cancelled'].includes(status))
  );

  constructor(
    private store: ViewWorkshopJobStoreService,
    private dialog: MatDialog,
    private vcr: ViewContainerRef
  ) {}

  addEvent(type: WorkshopJobEventType) {
    switch (type) {
      case 'assessment':
        this.dialog.open(AssessmentDialogComponent, {
          viewContainerRef: this.vcr,
          minWidth: '50vw'
        });
        break;
      case 'quotation':
        this.dialog.open(QuotationDialogComponent, {
          viewContainerRef: this.vcr,
          minWidth: '50vw'
        });
        break;
      case 'quote_approved':
        this.dialog.open(QuoteApprovedComponent, {
          viewContainerRef: this.vcr,
          minWidth: '50vw'
        });
        break;
      case 'waiting_for_parts':
        this.dialog.open(WaitingForPartsDialogComponent, {
          viewContainerRef: this.vcr,
          minWidth: '50vw'
        });
        break;
      case 'repair_started':
        this.dialog.open(RepairStartedDialogComponent, {
          viewContainerRef: this.vcr,
          minWidth: '50vw'
        });
        break;
      case 'completed':
        this.dialog.open(CompletedDialogComponent, {
          viewContainerRef: this.vcr,
          minWidth: '50vw'
        });
        break;
      case 'cancelled':
        this.dialog.open(CancelDialogComponent, {
          viewContainerRef: this.vcr,
          minWidth: '50vw'
        });
        break;
    }
  }
}
